import useApiService from 'services/api'
import { filterStoreRepo } from '../../../Filters/FilterStore'
import FilterModal, {
  FilterGroup,
  QuickFilterGroup,
} from '../../../Filters/components/FilterModal'
import { QuickShowHiddenFilter } from 'components/Filters/fields/QuickFilter'
import { RangeFilter } from '../../../Filters/fields/RangeFilter'
import { SelectFilter } from '../../../Filters/fields/SelectFilter'
import { FilterIdentifier } from 'models/saved_view'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { HOSPITAL_COLUMNS } from '../hospitalColumnsInfo'
import { CommonFiltersetAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetAccountGroup'
import { CommonFiltersetLocationGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetLocationGroup'

export function HospitalsFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = useApiService()
  const { data: campaignOptions } = api.useGetCampaignsOptions(
    'healthcare-hospitals',
    undefined,
    true
  )

  const hospitalsFilterStore = filterStoreRepo.getStore(filterIdentifier)

  const hospitalFilterHelper = createFilterColumnHelper({
    columns: HOSPITAL_COLUMNS,
  })

  return (
    <FilterModal identifier={filterIdentifier} store={hospitalsFilterStore}>
      <QuickFilterGroup>
        <QuickShowHiddenFilter filterStore={hospitalsFilterStore} />
      </QuickFilterGroup>
      <CommonFiltersetAccountGroup
        filterStore={hospitalsFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <FilterGroup title="Hospital Insights">
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('total_hospital_days')}
          store={hospitalsFilterStore}
        />
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('total_hospital_beds')}
          store={hospitalsFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Dining Services">
        <RangeFilter
          {...hospitalFilterHelper.retrieveProps('meals_per_day')}
          store={hospitalsFilterStore}
        />
        <SelectFilter
          {...hospitalFilterHelper.retrieveProps('cafeteria')}
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          filterStore={hospitalsFilterStore}
        />
        <SelectFilter
          {...hospitalFilterHelper.retrieveProps('dietary')}
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          filterStore={hospitalsFilterStore}
        />
        <SelectFilter
          {...hospitalFilterHelper.retrieveProps('dietary_under_contract')}
          options={[
            { value: '1', label: 'Yes' },
            { value: '0', label: 'No' },
          ]}
          filterStore={hospitalsFilterStore}
        />
      </FilterGroup>
      <CommonFiltersetLocationGroup
        filterStore={hospitalsFilterStore}
        stateSelectProps={hospitalFilterHelper.retrieveProps('state')}
        citySelectProps={hospitalFilterHelper.retrieveProps('city')}
      />
    </FilterModal>
  )
}
